export const chatKeys = {
  root: ['chat'] as const,
  scope: (accountId: number) => [...chatKeys.root, accountId] as const,
  conversations: (accountId: number) => [...chatKeys.scope(accountId), 'conversations'] as const,
  conversation: (accountId: number, id: number) =>
    [...chatKeys.scope(accountId), 'conversation', id] as const,
  messages: (accountId: number, id: number) => [...chatKeys.scope(accountId), 'messages', id] as const,
  directory: (accountId: number, search: string) =>
    [...chatKeys.scope(accountId), 'directory', search] as const,
  quoted: (accountId: number, id: number, messageIds: number[]) =>
    [...chatKeys.scope(accountId), 'quoted', id, messageIds] as const,
  attachmentUrls: (accountId: number, id: number, fileIds: string[]) =>
    [...chatKeys.scope(accountId), 'attachment-urls', id, fileIds] as const,
  broadcasts: (accountId: number, clientId: number | null) =>
    [...chatKeys.scope(accountId), 'broadcasts', clientId] as const,
  broadcastShifts: (accountId: number) => [...chatKeys.scope(accountId), 'broadcast-shifts'] as const,
  broadcast: (accountId: number, id: number) =>
    [...chatKeys.scope(accountId), 'broadcast', id] as const,
  reach: (accountId: number, clientId: number) => [...chatKeys.scope(accountId), 'reach', clientId] as const,
  shiftReach: (accountId: number, shiftId: number, guardUserIds: number[] | null) =>
    [...chatKeys.scope(accountId), 'reach', 'shift', shiftId, guardUserIds?.join(',') ?? 'all'] as const,
}
